import { render, staticRenderFns } from "./ehc-organization.vue?vue&type=template&id=0af38d7e"
import script from "./ehc-organization.vue?vue&type=script&lang=js"
export * from "./ehc-organization.vue?vue&type=script&lang=js"
import style0 from "./ehc-organization.vue?vue&type=style&index=0&id=0af38d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports